import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import cx from 'classnames';

import * as styles from './button.module.scss';

export const buttonType = {
  LIME: 'lime',
  DARK: 'dark',
  BLUE: 'blue',
  OUTLINE_BLUE: 'outline',
  OUTLINE_WHITE: 'outline_white',
  OUTLINE_DARK: 'outline_dark',
  OUTLINE_BLACK: 'outline_black',
};

export const Button = ({
  href,
  label,
  onClick,
  className,
  flexed = false,
  rel,
  target,
  type = buttonType.LIME,
  arrowType,
}) => {
  const attrs = {
    className: cx(
      styles.button,
      className,
      arrowType === 'right' && styles.buttonWithRightArrow,
      arrowType === 'down' && styles.buttonWithDownArrow,
      {
        [styles.flexed]: flexed,
        [styles.buttonLime]: type === buttonType.LIME,
        [styles.buttonDark]: type === buttonType.DARK,
        [styles.buttonBlue]: type === buttonType.BLUE,
        [styles.buttonOutlineBlue]: type === buttonType.OUTLINE_BLUE,
        [styles.buttonOutlineWhite]: type === buttonType.OUTLINE_WHITE,
        [styles.buttonOutlineDark]: type === buttonType.OUTLINE_DARK,
        [styles.buttonOutlineBlack]: type === buttonType.OUTLINE_BLACK,
      },
    ),
    onClick,
    rel,
    target,
  };
  if (href?.startsWith('http')) {
    return (
      <a href={href} {...attrs}>
        {label}
      </a>
    );
  }
  return href ? (
    <Link to={href} {...attrs}>
      {label}
    </Link>
  ) : (
    <button {...attrs}>{label}</button>
  );
};

Button.propTypes = {
  /**
   * Set to true if button is placed inside flexbox
   */
  flexed: PropTypes.bool,
  /**
   * Class name applied to the button
   */
  className: PropTypes.string,
  /**
   * Content text color
   */
  color: PropTypes.string,
  /**
   * Redirect url
   */
  href: PropTypes.string,
  /**
   * Button text content
   */
  label: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]),
  /**
   * onClick callback
   */
  onClick: PropTypes.func,
};
